import * as React from "react";
import { forwardRef } from "react";
const SvgExclamationOutline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.2232 0.00166702H10.7798V17.9917H13.2232V0.00166702ZM11.9998 20.165C10.9865 20.165 10.1665 21.025 10.1665 22.0817C10.1665 23.1383 10.9865 23.9983 11.9998 23.9983C13.0132 23.9983 13.8332 23.1383 13.8332 22.0817C13.8332 21.025 13.0132 20.165 11.9998 20.165Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgExclamationOutline);
export { ForwardRef as ReactComponent };
